/**
 * Sekcja usługi - wybor i ładowanie podglądu (modala) usługi
 */
app.service('productTabServices', function (modal, front, modalService, pageConfig, productCardConfig, loading, cartManager, serviceAvailability, productLimitedService, callback, serviceManager, lazyLoad, partnerSubscriptionManager, wcProductCardSubscriptionServices) {
	var $self, $wcZipCode;
	var config;

	function setElements() {
		$self = $('#services');
		config = productCardConfig.getData();
	}

	function loadWc() {
		load({
			wcZipCode: $wcZipCode.val()
		});
	}

	function setEvents(){
		if(front.katalog){

			$wcZipCode.mask2("99-999").keyup(function(event){		//dla katalogu
				if(event.keyCode == 13){
					loadWc();
				}
			});
			$('#services-button').click(function(){		//dla katalogu
				loadWc();
			});
		}
		partnerSubscriptionManager.checkedCheck(config.id);

		$('.js-service-info').on('click',function(){		// na karcie ale również w elemencie dosprzedażowym
			modalService.load({
				serviceId: $(this).data('service-id') || $(this).closest('.item').data('service-id'),
				productId: config.id
			});
		});
		$('.js-add-service-checkbox').on('change',function(){
			var place=($(this).closest('#product-for-sale').length)?'Usługi - Dosprzedaż':'Usługi - Zakładka';
			serviceManager.checkboxClick({
				serviceId: $(this).val(),
				productId: config.id,
				productPLU: config.plu,
				serviceChecked: $(this).is(':checked'),
				place:place
			});
		});

		$('.js-limited-wc-service', $self).on('click', function() {
			serviceAvailability.load($(this).data('service-code'));
		});

		$('.js-limited-service', $self).on('click', function() {
			var serviceId = $(this).data('service-id');
			UA.pageInteraction('Usługa', 'Sprawdź najbliższy termin - '+$("#service-name-"+serviceId).text());
			productLimitedService.load(serviceId, config.id);
		});
	}

	function load(params){
		if($self.length){
			var data=$.extend(true,{
				wcShopCode:pageConfig.getData('wc').shopCode,
				wcZipCode:pageConfig.getData('wc').cartZipCode,
				productId:config.id
			},params);
			$self.addClass('loading');
			$.ajax({
				url:'/product-card-service.ltr',
				data:data,
				success:function(html){
					loadSuccess(html, data);
					//$(window).trigger('product-menu-scroll');
				},
				error:function(){
					modal.alert('Błąd ładowania sekcji usług');
				},
				complete:function(){
					$self.removeClass('loading');
				}
			});
		}
	}

	function initLoad(){
		load();
	}

	function loadSuccess(html,data){
		$self.html(html);
		if(front.katalog){
			$wcZipCode = $('#services-zip-code');
			wcProductCardSubscriptionServices.init();
		}
		setEvents();
		lazyLoad.update();

	}
	function reload({ productId, outletCategoryId }) {
		var data={
			productId,
			outletCategoryId
		};
		if(front.katalog){
			data.wcShopCode=pageConfig.getData('wc').shopCode;
			data.wcZipCode=($wcZipCode && $wcZipCode.length && /[0-9]{2}\-[0-9]{3}/.test($wcZipCode.val()))?$wcZipCode.val():pageConfig.getData('wc').cartZipCode;
		}
		return $.ajax({
			url: '/product-card-service.ltr',
			data: data,
			success:function(html){
				loadSuccess(html,data);
			}
		}).fail(() => modal.alert('Błąd pobierania zakładki usług.'));
	}
	function init(){
		setElements();
		if(front.katalog){
			initLoad();
		}else{
			setEvents();
		}
		$(document).on('cartReady',function(){
			if($('#product-top').length){
				serviceManager.checkedCheck(config.id);
				partnerSubscriptionManager.checkedCheck(config.id);
			}
		});
	}

	return {
		init,
		reload
	};
});
